const getTopTrackId = (
	collection: ContentfulCollection
): number | undefined => {
	if (collection.topTrackId) return collection.topTrackId
	if (collection.albumsCollection?.items[0]?.trackId)
		return Number(collection.albumsCollection.items[0].trackId)
	if (collection.playlistsCollection?.items[0]?.trackIds)
		return Number(
			collection.playlistsCollection.items[0].trackIds.split(',')[0]
		)
	if (collection.artistsCollection?.items[0]?.trackId)
		return Number(collection.artistsCollection.items[0].trackId)
	return undefined
}

export const mapCollection = (collection: ContentfulCollection): Collection => {
	const mapped: Partial<Collection> = {
		id: collection.id,
		title: collection.title,
		description: collection.description,
		videoLarge: { url: collection.videoLarge?.url ?? null },
		videoMedium: { url: collection.videoMedium?.url ?? null },
		videoSmall: { url: collection.videoSmall?.url ?? null },
		videoPlaceholderImage: {
			url: collection.videoPlaceholderImage?.url ?? null,
		},
		heroBackground: { url: collection.heroBackground?.url ?? null },
		logo: {
			url: collection.logo?.url ?? null,
			height: collection.logo?.height ?? null,
		},
		perfectFor: collection.perfectFor,
		about: collection.about,
		quote: collection.quote,
		quoteAuthor: collection.quoteAuthor,
		quoteLogo: {
			url: collection.quoteLogo?.url ?? null,
			height: collection.quoteLogo?.height ?? null,
		},
		defaultSection: collection.defaultSection,
		campaignLanderCta: collection.campaignLanderCta,
		campaignLanderUrl: collection.campaignLanderUrl,
		artistNumber: collection.artistNumber,
		catalogue: collection.catalogue,
		totalAlbumNumber: collection.albumsCollection?.total,
		totalPlaylistNumber: collection.playlistsCollection?.total,
		previewTrackId: collection.topTrackId,
		createdAt: collection.sys?.firstPublishedAt,
		updatedAt: collection.sys?.publishedAt,
		albumCount: collection.albumsCollection?.total,
		playlistCount: collection.playlistsCollection?.total,
		artistCount: collection.artistsCollection?.total,
		thumbnailSquare: { url: collection.thumbnailSquare?.url ?? null },
		thumbnail: { url: collection.thumbnail?.url ?? null },
		thumbnailHover: { url: collection.thumbnailHover?.url ?? null },
		desktopHeroBackground: {
			url: collection.desktopHeroBackground?.url ?? null,
		},
		desktopHeroImage: { url: collection.desktopHeroImage?.url ?? null },
		mobileHeroBackground: { url: collection.mobileHeroBackground?.url ?? null },
		// Pick a style
		cardBackgroundImage: { url: collection.cardBackgroundImage?.url ?? null },
		cardLogo: { url: collection.cardLogo?.url ?? null },
		cardAlbumStack: { url: collection.cardAlbumStack?.url ?? null },
		cardBackgroundImageUrl: collection.cardBackgroundImage?.url ?? null,
		cardLogoUrl: collection.cardLogo?.url ?? null,
		cardAlbumStackUrl: collection.cardAlbumStack?.url ?? null,
		topTrackId: getTopTrackId(collection),
	}

	// Delete all unused entries (to make returned object precise)
	Object.keys(mapped).forEach(
		(key) => mapped[key] === undefined && delete mapped[key]
	)

	return mapped as Collection
}
